module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticStyle: {
      "display": "flex",
      "margin": "5px"
    }
  }, [_c('van-field', {
    attrs: {
      "size": "small",
      "placeholder": "请输入学员姓名",
      "clearable": ""
    },
    model: {
      value: (_vm.searchValue.name),
      callback: function($$v) {
        _vm.$set(_vm.searchValue, "name", $$v)
      },
      expression: "searchValue.name"
    }
  }), _vm._v(" "), _c('van-button', {
    staticStyle: {
      "width": "80px"
    },
    attrs: {
      "type": "info",
      "size": "small",
      "block": ""
    },
    on: {
      "click": _vm.queryList
    }
  }, [_vm._v("查询")])], 1), _vm._v(" "), _c('van-list', {
    attrs: {
      "finished": _vm.finished,
      "finished-text": "没有更多了"
    },
    on: {
      "load": _vm.onLoad
    },
    model: {
      value: (_vm.loading),
      callback: function($$v) {
        _vm.loading = $$v
      },
      expression: "loading"
    }
  }, _vm._l((_vm.list), function(item) {
    return _c('van-cell', {
      key: item.orderId
    }, [_c('div', {
      staticClass: "showInfo",
      on: {
        "click": function($event) {
          return _vm.openShowInfo(item)
        }
      }
    }, [_c('div', [_vm._v("学员姓名：" + _vm._s(item.name))]), _vm._v(" "), _c('div', [_vm._v("证件号：" + _vm._s(item.certId))]), _vm._v(" "), _c('div', [_vm._v("订单状态：" + _vm._s(item.orderStateName))]), _vm._v(" "), _c('div', [_vm._v("产品名称：" + _vm._s(item.productName.indexOf("A") > -1 ? "学驾易(驾考服务)A" : item.productName.indexOf("C") > -1 ? "学驾易(驾考服务)C" : "学驾易(驾考服务)"))]), _vm._v(" "), _c('div', [_vm._v("开始日期：" + _vm._s(item.insuranceStartTime))])])])
  }), 1), _vm._v(" "), (_vm.openShow) ? _c('van-popup', {
    style: ({
      height: '100%'
    }),
    attrs: {
      "position": "bottom",
      "close-on-popstate": true,
      "closeable": true
    },
    model: {
      value: (_vm.openShow),
      callback: function($$v) {
        _vm.openShow = $$v
      },
      expression: "openShow"
    }
  }, [_c('el-descriptions', {
    attrs: {
      "border": "",
      "column": 1
    }
  }, [_c('el-descriptions-item', {
    attrs: {
      "label": "保单编号"
    }
  }, [_vm._v(_vm._s(_vm.order.insuranceNo))]), _vm._v(" "), _c('el-descriptions-item', {
    attrs: {
      "label": "创建时间"
    }
  }, [_vm._v(_vm._s(_vm.order.createTime))]), _vm._v(" "), _c('el-descriptions-item', {
    attrs: {
      "label": "支付时间"
    }
  }, [_vm._v(_vm._s(_vm.order.payTime))]), _vm._v(" "), _c('el-descriptions-item', {
    attrs: {
      "label": "产品价格"
    }
  }, [_vm._v(_vm._s(_vm.order.orderFee + ' 元'))]), _vm._v(" "), _c('el-descriptions-item', {
    attrs: {
      "label": "产品ID"
    }
  }, [_vm._v(_vm._s(_vm.order.productId))]), _vm._v(" "), _c('el-descriptions-item', {
    attrs: {
      "label": "产品名称"
    }
  }, [_vm._v(_vm._s(_vm.order.productName.indexOf("A") > -1 ? "学驾易(驾考服务)A" : _vm.order.productName.indexOf("C") > -1 ? "学驾易(驾考服务)C" : "学驾易(驾考服务)"))]), _vm._v(" "), _c('el-descriptions-item', {
    attrs: {
      "label": "驾校名称"
    }
  }, [_vm._v(_vm._s(_vm.order.dsName))]), _vm._v(" "), _c('el-descriptions-item', {
    attrs: {
      "label": "用户名"
    }
  }, [_vm._v(_vm._s(_vm.order.name))]), _vm._v(" "), _c('el-descriptions-item', {
    attrs: {
      "label": "证件号"
    }
  }, [_vm._v(_vm._s(_vm.order.certId))]), _vm._v(" "), _c('el-descriptions-item', {
    attrs: {
      "label": "联系电话"
    }
  }, [_vm._v(_vm._s(_vm.order.contactNumber))]), _vm._v(" "), _c('el-descriptions-item', {
    attrs: {
      "label": "订单状态"
    }
  }, [_c('el-tag', {
    attrs: {
      "size": "small"
    }
  }, [_vm._v(_vm._s(_vm.order.orderStateName))])], 1), _vm._v(" "), (_vm.order.orderStateName == '保障中') ? _c('el-descriptions-item', {
    attrs: {
      "label": "保障时间"
    }
  }, [_vm._v("\n          " + _vm._s(_vm.order.insuranceStartTime + '至' + _vm.order.insuranceEntTime))]) : _vm._e(), _vm._v(" "), _c('el-descriptions-item', {
    attrs: {
      "label": "正面图片"
    }
  }, [(_vm.order.positiveImage !== '') ? _c('el-image', {
    staticStyle: {
      "width": "150px",
      "height": "50px"
    },
    attrs: {
      "alt": "点击预览",
      "src": _vm.order.positiveImage,
      "preview-src-list": _vm.imagesUrl
    }
  }, [_c('div', {
    staticClass: "image-slot imageSlot",
    attrs: {
      "slot": "error"
    },
    slot: "error"
  }, [_c('i', {
    staticClass: "el-icon-picture-outline"
  })])]) : _vm._e(), _vm._v(" "), (_vm.order.positiveImage === '') ? _c('span', [_vm._v("-")]) : _vm._e()], 1), _vm._v(" "), _c('el-descriptions-item', {
    attrs: {
      "label": "反面图片"
    }
  }, [(_vm.order.negativeImage !== '') ? _c('el-image', {
    staticStyle: {
      "width": "150px",
      "height": "50px"
    },
    attrs: {
      "alt": "点击预览",
      "src": _vm.order.negativeImage,
      "preview-src-list": _vm.imagesUrl
    }
  }, [_c('div', {
    staticClass: "image-slot imageSlot",
    attrs: {
      "slot": "error"
    },
    slot: "error"
  }, [_c('i', {
    staticClass: "el-icon-picture-outline"
  })])]) : _vm._e(), _vm._v(" "), (_vm.order.negativeImage === '') ? _c('span', [_vm._v("-")]) : _vm._e()], 1)], 1)], 1) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-286ef22a"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/driverSchool/myOrders.vue
// module id = 471
// module chunks = 1